import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Chip, } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { OpenSwal } from '../../Utils';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import { LoadingButton } from '@mui/lab';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Divider } from '@mui/material';
// import LanguageIcon from '@mui/icons-material/Language';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import dayjs from 'dayjs';
import { url_assignment_accept_reject } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';


function AssignmentAcceptComp({ AssignmentDetailsAry, changeAssignStatus, AssignmentCustomerPromtBeforeAcceptAry, assign_id }) {
    const [AccectButtonLoading, AccectButtonLoadingSet] = useState(false);
    const [RejectButtonLoading, RejectButtonLoadingSet] = useState(false);
    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    // changeAssignStatus("test");
    const AssignmentAcceptReject = (btn_status) => {

        if (btn_status === "Accept") AssignmentAcceptRejectAxios(btn_status);
        else if (btn_status === "Reject") {
            Swal.fire({
                title: 'Reject Assignment',
                text: "Do you want to reject assignment no. " + AssignmentDetailsAry.assign_orderid,
                showCancelButton: true,
                icon: "error",
                confirmButtonText: "Confirm",
                cancelButtonColor: '#f44336',
                confirmButtonColor: '#89B601',
                cancelButtonText: "Cancel",
                color: appThemeColor
            }).then((result) => {
                if (result.isConfirmed) {
                    AssignmentAcceptRejectAxios(btn_status);
                }
            });
        }


    }


    const AssignmentAcceptRejectAxios = (btn_status) => {

        if (btn_status === "Accept") AccectButtonLoadingSet(true);
        else if (btn_status === "Reject") RejectButtonLoadingSet(true);
        let payload_data = { assignid: assign_id, status: btn_status }

        apiWithAuth.post(url_assignment_accept_reject, payload_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                let title_text = "";
                if (btn_status === "Accept") {
                    title_text = "Assignment Accepted";
                } else {
                    title_text = "Assignment Rejected";
                }
                Swal.fire({
                    title: title_text,
                    text: response.data.message,
                    confirmButtonText: 'Ok',
                    icon: "success",
                    confirmButtonColor: "#89B601",
                    color: appThemeColor
                }).then((result) => {
                    if (btn_status === "Accept") changeAssignStatus("Accepted");
                    else if (btn_status === "Reject") changeAssignStatus("Rejected");
                });

            } 
            // else if (response.data.status === false && response.data.is_48hrs_above) {
            //     Swal.fire({
            //         title: 'Active Assignment',
            //         text: response.data.message,
            //         confirmButtonText: 'Yes',
            //         cancelButtonText: 'No',
            //         cancelButtonColor: '#f44336',
            //         reverseButtons: true,
            //         showCancelButton: true,
            //         icon: "success",
            //         confirmButtonColor: "#89B601",
            //         color: appThemeColor
            //     }).then((result) => {
            //         if (result.isConfirmed) {
            //             navigate('/Interpreter/Active_list');
            //         } else {
            //             AccectButtonLoadingSet(false);
            //         }
            //     });
            // } 
            else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                AccectButtonLoadingSet(false);
                RejectButtonLoadingSet(false)
                OpenSwal('Axios_error', response.data.message);
            }

        }).catch(response => OpenSwal('Axios_error', response.message));

    }
    return (
        <Box>
            <Box sx={{ mt: 2, ml: 1 }}>

                <Stack direction="row" spacing={1}>
                    <Typography variant="h6" sx={{ padding:"20px 0px 0px 0px" }} fontWeight="bold" color={appThemeColor}>  {AssignmentDetailsAry.assign_industry} </Typography> {AssignmentDetailsAry.assign_applicant_counts === 1 && <Box sx={{ display: 'flex', alignItems: 'center' }}> <Chip label={<Typography variant='caption'>Only to You</Typography>} size="small" sx={{ backgroundColor: '#89B601', color: '#fff', borderRadius: 2, height: '18px' }} /></Box>}
                </Stack>
                <Typography variant="h6" fontWeight="bold" color={appThemeColor} sx={{ mt: -1 }}  > {AssignmentDetailsAry.assign_client_name} </Typography>
                <Box sx={{ display: 'flex' }}>
                    <TranslateOutlinedIcon sx={{ color: appThemeColor, fontSize: '16px', mt: '2px', mr: 0.2 }} /> <Typography variant="subtitle2" color={appThemeColor} > {AssignmentDetailsAry.language_name} | {AssignmentDetailsAry.service_type_short} </Typography>
                </Box>
                <Box sx={{ mt: 1 }}>
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Mode</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='caption' color={appThemeColor}>{AssignmentDetailsAry.assign_service_mode}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    {/* <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Reporting Time</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentDetailsAry.assign_reporting_time).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} /> */}
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Time Zone</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_timezone_daylight}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Requested Duration</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_duration}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Location</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_location}</ Typography></Box></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Special Instructions</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_instruction}</ Typography></Box></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Consumer of Service</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_consumer_service_name}</ Typography></Box></Grid> </Grid>
                    {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box>
                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Venue Remarks</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_add_row_by_service_type}</ Typography></Box></Grid> </Grid>
                    </Box>}
                </Box>
            </Box>
            {AssignmentCustomerPromtBeforeAcceptAry.length !== 0 &&
                <Box sx={{ mt: 1, ml: 1 }}>
                    <Typography variant="h6" fontWeight="bold" color={appThemeColor} > Customer Prompt </Typography>
                    {AssignmentCustomerPromtBeforeAcceptAry.map((customer_promt, index) => {
                        var customer_promt_obj_key = Object.keys(customer_promt);

                        return (<Box key={index} >
                            <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'  >{customer_promt_obj_key}</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{customer_promt[customer_promt_obj_key]}</ Typography></Grid> </Grid>
                            <Divider sx={{ borderRadius: '10px' }} />
                        </Box>);
                    })}
                </Box>
            }

            <Box sx={{ mt: 3, ml: { xs: 0, sm: 0, md: 1 } }}>

                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Stack spacing={{ xs: 2, sm: 3, md: 4 }} direction='row'>
                        <LoadingButton variant="contained" size="small" sx={{ backgroundColor: '#89B601', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' }, width: '110px', height: { xs: 'auto', md: '35px' } }} loadingPosition="start" onClick={() => AssignmentAcceptReject('Accept')} loading={AccectButtonLoading} startIcon={<CheckCircleOutlineOutlinedIcon />}>Accept</LoadingButton>
                        <LoadingButton variant="contained" size="small" sx={{ backgroundColor: '#f44336', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#aa2e25' }, width: '110px', height: { xs: 'auto', md: '35px' } }} loadingPosition="start" onClick={() => AssignmentAcceptReject('Reject')} loading={RejectButtonLoading} startIcon={<CancelOutlinedIcon />}>Reject</LoadingButton>
                    </Stack>

                </Box>
            </Box>
        </Box>
    )
}

export default AssignmentAcceptComp